import IServiceConfig from './IServiceConfig'

const ProductionConfig: IServiceConfig = {
  BaseUrl: 'https://cms.piersgil.nl'
}

export default ProductionConfig
